import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from "@angular/core";

import { ArgTypes } from "@storybook/angular/types-6-0";
import { InputYear } from "@vattenfall/util";

import { DatesElementAccessor } from "../dates-accessor";

export const argTypesYear: ArgTypes = <const>{
  format: {
    control: "text",
    description:
      "Date format string. The characters in the format string wrapped between two single quotes characters (') are escaped. Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote. Default is `YYYY`.",
    table: {
      category: "Inputs",
      type: {
        summary: "string",
      },
    },
  },
};

/**
 * A control for entering a date consisting of a year number.
 *
 * Values can be provided and read as a integer representing a year, in which case the properties ending in `AsDate` should be used. A custom `format` can be provided to support regional variations for displaying dates.
 *
 * Text inputs can be used as an Angular `FormControl`, in both reactive and template driven forms.
 */
@Component({
  selector: "ui-input[type=year]",
  templateUrl: "./year.component.html",
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputYearComponent extends DatesElementAccessor<InputYear> {
  /**
   * Date format string.
   *
   * The characters in the format string wrapped between two single quotes characters (') are escaped. Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
   *
   * Read more at [date-fns](https://date-fns.org/v2.29.3/docs/parse).
   *
   * Default is `YYYY`.
   */
  @Input() format = "YYYY";
}
